import {Routes} from 'constants/routes';
import {FILES_PAGE_ID, MenuItem, ServerMenuCode, ServerMenuTabType} from 'utils';

const computeUrl = (item: MenuItem, wellId: string) => {
    if (item.isFiles) {
        return `${Routes.Files}/${wellId}/${FILES_PAGE_ID}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.KnbkGisGroups].includes(item.type)) {
        return `${Routes.KnbkGis}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.DrillingRigInWell].includes(item.type)) {
        return `${Routes.DrillingRigInWell}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.MudAnalytics].includes(item.type)) {
        return `${Routes.MudAnalytics}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.CasingColumnDescentProtocol].includes(item.type)) {
        return `${Routes.Ccdp}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.Prices].includes(item.type)) {
        return `${Routes.Prices}/${wellId}`;
    }
    if ([ServerMenuTabType.Ggd].includes(item.type)) {
        return `${Routes.Ggd}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.KnbkDrillingGroups].includes(item.type)) {
        return `${Routes.Knbk}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.InstrumentMeasure].includes(item.type)) {
        return `${Routes.InstrumentMeasure}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.KPODescentProtocol].includes(item.type)) {
        return `${Routes.Kpodp}/${wellId}/${item.pathCode}`;
    }
    if ([ServerMenuTabType.WellRisks].includes(item.type)) {
        return `${Routes.WellRisks}/${wellId}/${item.pathCode}`;
    }

    if (
        [
            ServerMenuTabType.CalendarOperations,
            ServerMenuTabType.MudFactCalendar,
            ServerMenuTabType.OperationDetalization,
        ].includes(item.type)
    ) {
        return `${Routes.Calendar}/${wellId}/${item.pathCode}`;
    }

    if ([ServerMenuTabType.Nested].includes(item.type) && item.children) {
        return item.children.map((child) => `${Routes.Tables}/${wellId}/${child.pathCode}`);
    }

    return `${Routes.Tables}/${wellId}/${item.pathCode}${item.type === ServerMenuTabType.TableV2 ? '/2' : ''}`;
};

const computeUrlBaseOnMenuCode = (item: MenuItem, wellId: string) => {
    const menuTypeCode = item.menuTypeCode;
    if (!menuTypeCode) {
        throw new Error('menuTypeCode is not present');
    }
    if (ServerMenuCode.WellCommonDashboard === menuTypeCode) {
        return `${Routes.WellCommonDashboard}/${wellId}`;
    }
    const itemToNavigateTo = item.childToRedirectTo ?? item;
    return computeUrl(itemToNavigateTo, wellId);
};

export const getUrlForMenuItem = (item: MenuItem, wellId: string) => {
    if (item.menuTypeCode) {
        return computeUrlBaseOnMenuCode(item, wellId);
    }
    const itemToNavigateTo = item.childToRedirectTo ?? item;
    return computeUrl(itemToNavigateTo, wellId);
};

export const getChildUrlsForMenuItem = (item: MenuItem, wellId: string) => {
    const result = item.children?.reduce((acc: string[], item) => {
        const url = computeUrl(item, wellId);
        if (Array.isArray(url)) {
            acc.push(...url);
            return acc;
        } else {
            acc.push(url);
            return acc;
        }
    }, []);

    if (item.menuTypeCode === ServerMenuCode.WellCommonDashboard) {
        const url = computeUrl(item, wellId);
        if (Array.isArray(url)) {
            result?.push(...url);
        } else {
            result?.push(url);
        }
    }
    return result;
};
